module.exports = __webpack_public_path__ + "img/landing_content_example_3.ba184c96.png";